export const NBX_SUPPORTED_METRICS = [
  "spend",
  "rev",
  "roas",
  "cac",
  "newCac",
  "cpv",
  "rpv",
  "cpc",
  "ctr",
  "cpm",
];
